import assembleURLHash from './route/assembleURLHash';

export default function hrefModuleList(params) {
    if (params.type === 'rightPanel') {
        this.dataSet('rightPanel', {}, 'RightPanel');

        return;
    }
    if (params.blank) {
        window.open(assembleURLHash('list', params.relModule), '_blank');
    } else {
        this.href(assembleURLHash('list', params.relModule));
    }
}
